/**
 * These are passed as props to the day picker controllers to customize the
 * styling of the next and previous month navigation buttons.
 *
 * Disabling jsx-a11y/no-noninteractive-tabindex because the role="button" is
 * added by react-dates to the parent, but it is not given a tabIndex :-(
 */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


import React from 'react';
import { IconArrowBack, IconArrowForward } from '../icons/Icons'

export const PreviousMonthButton = () => {
    return (
        <div className="sarsa-day-picker-range-controller-month-navigation-button left" tabIndex="0">
            <IconArrowBack size="md" />
        </div>
    );
}

export const NextMonthButton = () => {
    return (
        <div className="sarsa-day-picker-range-controller-month-navigation-button right" tabIndex="0">
            <IconArrowForward size="md" />
        </div>
    );
}